var _defs, _ellipse, _g, _path, _g2, _path2, _path3, _g3, _polygon, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyEmailDashboardIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1076.14 843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#151616;}.cls-1,.cls-9{opacity:0.2;}.cls-2{opacity:0.7;}.cls-3{fill:#e2e2e2;}.cls-4{fill:#dee6f1;}.cls-5{opacity:0.3;}.cls-6{opacity:0.1;}.cls-7{opacity:0.5;}.cls-8{fill:#fff;}.cls-9{fill:none;stroke:#007cff;stroke-miterlimit:10;stroke-width:8.9px;}.cls-10{fill:#007cff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    cx: 538.07,
    cy: 816.78,
    rx: 538.07,
    ry: 26.22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200,380.36l667.72-4.85,16.88,411.74a40.19,40.19,0,0,1-40.52,41.83l-608.88-5.65a40.18,40.18,0,0,1-39.81-40.64Z",
    transform: "translate(-1.93 -118.5)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200,380.36,508.87,130.42a47.55,47.55,0,0,1,60.06.19l298.78,244.9",
    transform: "translate(-1.93 -118.5)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,380.36l311.79-252.3a43,43,0,0,1,54.26.18L867.71,375.51",
    transform: "translate(-1.93 -118.5)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.76,811.19c-.8.82,37.78-47.27,104.54-118.47S435.88,564.41,436.71,565.19,384.1,624.32,317.32,695.55,226,794.49,209.76,811.19Z",
    transform: "translate(-1.93 -118.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M875.81,815.26c-.85.76-42.4-42.22-105.75-113.5S656,572.05,656.88,571.29,709.78,627.71,773.15,699,876.66,814.5,875.81,815.26Z",
    transform: "translate(-1.93 -118.5)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "865.78 257 530.48 524.86 198.06 261.86"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "231.68 286.66 230.71 92.42 815.52 78.11 821.9 290.63 530.45 521.35 231.68 286.66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 536.62,
    cy: 305.32,
    r: 142.43
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M444.56,435.47,461,415.36a5.76,5.76,0,0,1,7.83-1l46.44,33.55a5.76,5.76,0,0,0,7.76-.94l82.39-97.11a5.76,5.76,0,0,1,8.19-.6l18.33,16.12a5.76,5.76,0,0,1,.54,8.1l-108,124.41a5.75,5.75,0,0,1-7.86.79l-71.14-55A5.75,5.75,0,0,1,444.56,435.47Z",
    transform: "translate(-1.93 -118.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmailDashboardIllustration);
export default __webpack_public_path__ + "static/media/Verify_email_dashboard_illustration.7986829f81e64a7ed2d49260f11e5aaf.svg";
export { ForwardRef as ReactComponent };